/** Largest exact count shown on badges and counters. Above this, UI shows "9+". */
export const COUNT_CAP = 9;

export function formatCountCap(count: number): string {
  const value = Math.max(0, Math.floor(count));
  return value > COUNT_CAP ? `${COUNT_CAP}+` : String(value);
}
